var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.52532C2 8.84503 2.33189 8.20943 2.88513 7.83021L10.8851 2.34665C11.5594 1.88445 12.4406 1.88445 13.1149 2.34665L21.1149 7.83021C21.6681 8.20943 22 8.84503 22 9.52532V19.9582C22 21.0859 21.1046 22 20 22H15V16.8956C15 15.2042 13.6569 13.833 12 13.833C10.3431 13.833 9 15.2042 9 16.8956V22H4C2.89543 22 2 21.0859 2 19.9582V9.52532ZM11.25 11.6947V9.49423H9.09451C9.36585 10.5704 10.1958 11.4177 11.25 11.6947ZM12.75 9.49423V11.6947C13.8042 11.4177 14.6342 10.5704 14.9055 9.49423H12.75ZM12.75 7.96291H14.9055C14.6342 6.8867 13.8042 6.03942 12.75 5.76243V7.96291ZM11.25 7.96291V5.76243C10.1958 6.03942 9.36585 6.8867 9.09451 7.96291H11.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome10);
export default __webpack_public_path__ + "static/media/home-10.c5c402a40e4cb1006f165c3f661c8c27.svg";
export { ForwardRef as ReactComponent };